import firebase from 'firebase'
import { changeStatusCampaignContent } from '@/service/influencer/campaignContent'

const state = {
  dialog: {
    show: false,
    status: ''    
  }
}

const getters = {
  dialogChangeStatusStore: state => state.dialog
}

const actions = {
  async changeStatusCampaignContent({commit, state}, {contentId, influencerId}) {
    const data = {
      content: contentId,
      influencer: influencerId,
      status: state.dialog.status,
      usertoken: firebase.auth().currentUser.uid
    }
    const response = await changeStatusCampaignContent(data)
    if (response.data.success) {
      commit('updateCampaignContentDetail', data)
    }
    commit('closeDialogChangeStatus')
  }
}

const mutations = {
  openDialogChangeStatus(state, data) {
    state.dialog.show = true
    state.dialog.status = data
  },
  closeDialogChangeStatus(state) {
    state.dialog.show = false 
    state.dialog.status = ''   
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}